import api from 'services/api';

const FILES_FETCH_COLLECTION = 'files/fetchCollection';
const FILES_LOAD_MORE = 'files/loadMore';
const FILES_UPLOAD = 'files/upload';
const FILES_UPLOAD_IMAGE = 'files/uploadImage';
const FILES_LOADING = 'files/loading';
const FILES_DELETE = 'files/delete';

const actions = {
  fetchCollection(query) {
    return {
      type: FILES_FETCH_COLLECTION,
      payload: api.get('/data/:files', query),
      meta: { query },
    };
  },

  loadMore(query) {
    return {
      type: FILES_LOAD_MORE,
      payload: api.get('/data/:files', query),
      meta: { query },
    };
  },

  uploadFile(file, sizeType = undefined) {
    return {
      type: FILES_UPLOAD,
      payload: api.post(
        '/data/:files',
        {
          data: {
            $base64: file.data.replace(/data:.*?base64,/, ''),
          },
          content_type: file.type,
          filename: file.filename,
        },
        {
          ...(sizeType ? { [`swell-upload-${sizeType}`]: 'true' } : {}),
        },
      ),
      meta: { file },
    };
  },

  updateFile(id, file) {
    return {
      type: FILES_UPLOAD,
      payload: api.put('/data/:files/{id}', {
        id,
        data: {
          $base64: file.data.replace(/data:.*?base64,/, ''),
        },
        content_type: file.type,
        filename: file.filename,
      }),
      meta: { file },
    };
  },

  uploadImage(image) {
    return {
      type: FILES_UPLOAD_IMAGE,
      payload: api.post('/data/:files', {
        data: {
          $base64: image.data.replace(/data:.*?base64,/, ''),
        },
        content_type: image.type,
        filename: image.filename,
        width: image.width,
        height: image.height,
      }),
      meta: { image },
    };
  },

  delete(file) {
    return {
      type: FILES_DELETE,
      payload: api.delete('/data/:files/{id}', {
        id: file.id,
      }),
      meta: { file },
    };
  },
};

export default actions;

export const initialState = {
  collection: null,
  errors: {},
  loading: false,
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET':
      return initialState;
    case FILES_FETCH_COLLECTION:
      return {
        ...state,
        ...action.meta,
        collection: {
          ...action.payload,
          totalPages: Math.ceil(action.payload.count / action.meta.query.limit),
        },
      };

    case FILES_LOAD_MORE:
      return {
        ...state,
        ...action.meta,
        collection: {
          ...state.collection,
          results: [...state.collection.results, ...action.payload.results],
          page: action.payload.page,
          pages: {
            ...(state.collection.pages || {}),
            ...(action.payload.pages || {}),
          },
          totalPages: Math.ceil(action.payload.count / action.meta.query.limit),
        },
      };

    case FILES_UPLOAD:
      if (action.payload.errors) {
        return {
          ...state,
          errors: action.payload.errors,
        };
      }
      return state;

    case FILES_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}
